<div class="prisma-flow">
  <h2 class="prisma-title">PRISMA flow diagram</h2>

  <div class="prisma-flow--container">
    <div class="vertical-step bg-identification">Identification</div>
    <div class="prisma-flow--sections">
      <div class="prisma-flow--section">
        <div class="prisma-flow--step">
          <div class="section-header purple">Identification via databases</div>
          <div class="box bg-identification">
            <p><strong>Records identified</strong> (n={{externalSourcesCount}})</p>
            <ul>
              @for (paperSource of paperSources | keyvalue; track $index) {
                @if (paperSource.key !== 'SELF_CREATED') {
                  <li>{{ paperSource.key }} (n={{ paperSource.value }})</li>
                }
              }
            </ul>
          </div>
          <svg class="arrow-down svg-identification" width="35" height="50" viewBox="0 0 40 80"
               xmlns="http://www.w3.org/2000/svg">
            <line x1="20" y1="15" x2="20" y2="60" stroke-width="4"/>
            <polygon points="0,60,40,60,20,80"/>
          </svg>
        </div>
        <div class="prisma-flow--step">
          <div class="section-header purple">Manual identification</div>
          <div class="box bg-identification">
            <p><strong>Records identified from:</strong></p>
            <ul>
              <li>Manual (n={{ manualSources }})</li>
            </ul>
          </div>
          <svg class="arrow-down svg-identification" width="35" height="50" viewBox="0 0 40 80"
               xmlns="http://www.w3.org/2000/svg">
            <line x1="20" y1="15" x2="20" y2="60" stroke-width="4"/>
            <polygon points="0,60,40,60,20,80"/>
          </svg>
        </div>
      </div>
    </div>
  </div>


  <div class="prisma-flow--container">
    <div class="vertical-step bg-screening">Screening</div>
    <div class="prisma-flow--sections">
      <div class="prisma-flow--section">
        <div class="prisma-flow--step">
          <div class="box bg-screening">
            <p><strong>Records after duplicates removed</strong> (n={{ allPapersCount }})</p>
          </div>
          <svg class="arrow-down svg-screening arrow-down--25" width="35" height="50" viewBox="0 0 40 80"
               xmlns="http://www.w3.org/2000/svg">
            <line x1="20" y1="15" x2="20" y2="40" stroke-width="4"/>
            <polygon points="0,30,40,30,20,50"/>
          </svg>
        </div>
      </div>

      <div class="prisma-flow--section">
        <div class="prisma-flow--step">
          <div class="box bg-screening box--height-100">
            <p><strong>Titles and Abstracts screened</strong>
              <span class="screened-count">(n={{ screening1AuditedCount }})</span>
              <mat-icon class="screened-info" matSuffix
                        matTooltip="Screening 1 is the first step of the screening process. In this step, the titles and abstracts of the papers are screened.">
                info
              </mat-icon>
            </p>
            <ul>
              <li>Passed via manual (n={{ screeningPassedManuel1Count }})</li>
              <li>Passed via Academate (n={{ screening1PassedCount }})</li>
              <li><strong>Passed total</strong> (n={{ screening1PassedCount + screeningPassedManuel1WithoutAcCount }})</li>
            </ul>
          </div>
          <svg class="arrow-down svg-screening" width="35" height="50" viewBox="0 0 40 80"
               xmlns="http://www.w3.org/2000/svg">
            <line x1="20" y1="15" x2="20" y2="40" stroke-width="4"/>
            <polygon points="0,30,40,30,20,50"/>
          </svg>

          <svg class="arrow-right svg-screening" width="35" height="50" viewBox="0 0 40 80"
               xmlns="http://www.w3.org/2000/svg">
            <line x1="20" y1="15" x2="20" y2="60" stroke-width="4"/>
            <polygon points="0,55,40,55,20,70"/>
          </svg>
        </div>
        <div class="prisma-flow--step">
          <div class="box bg-screening">
            <p><strong>Titles and Abstracts excluded</strong> (n={{ screening1FailedCount }})</p>
            <ul>
              @for (paperSource of screening1Passed | keyvalue; track $index) {
                <li>{{ paperSource.key }} (n={{ paperSource.value }})</li>
              }
            </ul>
          </div>
        </div>
      </div>

      <div class="prisma-flow--section">
        <div class="prisma-flow--step">
          <div class="box bg-screening box--height-100">
            <p>
              <strong>Full-text screened</strong>
              <span class="screened-count">(n={{ screening2AuditedCount }})</span>
              <mat-icon class="screened-info" matSuffix
                        matTooltip="Screening 2 is the second step of the screening process. In this step, the full-texts of the papers are screened. Independently from the first step.">
                info
              </mat-icon>
            </p>
            <ul>
              <li>Passed via manual (n={{ screeningPassedManuel2Count }})</li>
              <li>Passed via Academate (n={{ screening2PassedCount }})</li>
              <li><strong>Passed total</strong> (n={{ screeningPassedTotalCount }})</li>
            </ul>
          </div>
          <svg class="arrow-down svg-inclusion" width="35" height="50" viewBox="0 0 40 80"
               xmlns="http://www.w3.org/2000/svg">
            <line x1="20" y1="15" x2="20" y2="60" stroke-width="4"/>
            <polygon points="0,60,40,60,20,80"/>
          </svg>

          <svg class="arrow-right svg-screening" width="35" height="50" viewBox="0 0 40 80"
               xmlns="http://www.w3.org/2000/svg">
            <line x1="20" y1="15" x2="20" y2="60" stroke-width="4"/>
            <polygon points="0,55,40,55,20,70"/>
          </svg>
        </div>
        <div class="prisma-flow--step">
          <div class="box bg-screening">
            <p><strong>Full-text excluded</strong> (n={{ screening2FailedCount }})</p>
            <ul>
              @for (paperSource of screening2Passed | keyvalue; track $index) {
                <li>{{ paperSource.key }} (n={{ paperSource.value }})</li>
              }
            </ul>
          </div>
        </div>
      </div>

    </div>
  </div>


  <div class="prisma-flow--container">
    <div class="vertical-step bg-inclusion">Inclusion</div>
    <div class="prisma-flow--sections">
      <div class="prisma-flow--section">
        <div class="prisma-flow--step">
          <div class="box bg-inclusion">
            <p><strong>Records included</strong> (n={{ screeningPassedTotalCount }}))</p>
            <ul>
              <li>Passed via manual (n={{ screeningPassedManuel2Count }})</li>
              <li>Passed via Academate (n={{ screening2PassedCount }})</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
